export class Where {
    field: string;
    operator: any;
    value: string | number | boolean;

    static lt(field: string, value: any): Where {
        return {
            field: field,
            operator: '<',
            value: value
        }
    }

    static le(field: string, value: any): Where {
        return {
            field: field,
            operator: '<=',
            value: value
        }
    }

    static eq(field: string, value: any): Where {
        return {
            field: field,
            operator: '==',
            value: value
        }
    }

    static ne(field: string, value: any): Where {
        return {
            field: field,
            operator: '!=',
            value: value
        }
    }
    static ge(field: string, value: any): Where {
        return {
            field: field,
            operator: '>=',
            value: value
        }
    }
    static gt(field: string, value: any): Where {
        return {
            field: field,
            operator: '>',
            value: value
        }
    }
}
export class OrderBy {
    field: string;
    sort: any = 'asc';

    static asc(field): OrderBy {
        return {
            field: field,
            sort: 'asc'
        }
    }
    static desc(field): OrderBy {
        return {
            field: field,
            sort: 'desc'
        }
    }
}
export class TQuery {
    where?: Where | Where[];
    orderBy?: OrderBy | OrderBy[];
}

interface Lang {
    key: string,
    title: string,
    val: string
}
export class Language {
    static CODE: Lang[] = [{
        key: 'en',
        title: '英文',
        val: '英文',
    }, {
        key: 'zh_hant',
        title: '繁中',
        val: '繁中',
    }];
    // static CODE: Lang[] = [{
    //     key: 'en',
    //     title: '英文',
    //     val: '英文',
    // }, {
    //     key: 'zh_hant',
    //     title: '繁中',
    //     val: '繁中',
    // }, {
    //     key: 'ja',
    //     title: '日文',
    //     val: '日本語',
    // }, {
    //     key: 'th',
    //     title: '泰文',
    //     val: 'ภาษาไทย',
    // }];

    static getCode() {
        return this.CODE.map(val => Object.values(val)[0].replace('_', '-'));
    }
}